import { Routes } from '@angular/router';
import { UserProfileComponent } from '../page/user-profile/user-profile.component';
import { GoalsIndividualComponent } from 'app/goals/goals-components/goals-individual/goals-individual.component';
import { ProfilePraiseFullComponent } from '../component/profile-praise-full/profile-praise-full.component';
import { ProfileRestrictedComponent } from '../component/profile-restricted/profile-restricted.component';
import { ProfileAccessGuard } from '@app/shared/auth/profile-access.guard';

export const ProfileRoutes: Routes = [
  // Declared before ':id' so the word is not read as a user id.
  { path: 'restricted', component: ProfileRestrictedComponent, data: { label: 'Profile' } },
  {
    path: '', component: UserProfileComponent, data: { label: 'My Profile' }, children: [
      { path: 'goals/individual/:id', component: GoalsIndividualComponent, data: { label: 'Goal' } },
      {
        path: 'connect',
        loadChildren: () => import('../../../connect/connect.module').then(m => m.ConnectModule)
      },
      {
        path: 'feedback',
        loadChildren: () => import('app/feedback/feedback.module').then(m => m.FeedbackModule)
      }
    ]
  },
  {
    path: ':id', component: UserProfileComponent, canActivate: [ProfileAccessGuard], canActivateChild: [ProfileAccessGuard], data: { label: 'Profile' }, children: [
      { path: 'goals/individual/:id', component: GoalsIndividualComponent, data: { label: 'Goal' } },
      { path: 'individual/:id', component: GoalsIndividualComponent, data: { label: 'Goal' } },
      {
        path: 'connect',
        loadChildren: () => import('../../../connect/connect.module').then(m => m.ConnectModule)
      },
      {
        path: 'feedback',
        loadChildren: () => import('app/feedback/feedback.module').then(m => m.FeedbackModule)
      },
      { path: 'praise', component: ProfilePraiseFullComponent, data: { label: 'Praise' } }
    ]
  }
];

